import { updateCalendarCloudSettings } from '../actions/internalActions';
import { initCalendarCloudSettings } from '../actions/publicActions';
import getCalendarCloudSettingsService from '../services/getCalendarCloudSettingsService';
import lightupOnlineMeetingFRE from '../utils/lightupOnlineMeetingFRE';
import lightupSpeedyMeetingsFRE from '../utils/lightupSpeedyMeetingsFRE';
import shouldInitCalendarCloudSettings from '../utils/shouldInitCalendarCloudSettings';
import { orchestrator } from 'satcheljs';

/**
 * Initializes the calendar cloud settings - gets settings from OCS
 */
orchestrator(initCalendarCloudSettings, async () => {
    if (shouldInitCalendarCloudSettings()) {
        // If we don't have the calendar cloud settings already, we get them from OCS
        const calendarCloudSettings = await getCalendarCloudSettingsService();
        if (!calendarCloudSettings) {
            return;
        }

        updateCalendarCloudSettings(calendarCloudSettings);
    }

    lightupOnlineMeetingFRE();
    lightupSpeedyMeetingsFRE();
});
